import { render, staticRenderFns } from "./ExamQuestionAdd.vue?vue&type=template&id=62a64cea&"
import script from "./ExamQuestionAdd.vue?vue&type=script&lang=js&"
export * from "./ExamQuestionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports